import Menu, { MenuProps } from "@mui/material/Menu";
import { alpha, styled } from "@mui/material/styles";

// Menu-item icons render at this size in both icon families. MUI SvgIcons
// track font-size (they are 1em x 1em), while Lucide icons size via their
// width/height attributes, so the one value has to be applied through
// different properties below to keep the two families in lockstep.
const MENU_ITEM_ICON_SIZE = 18;

export const RobotoStyledPopoverMenu = styled((props: MenuProps) => (
  <Menu
    elevation={0}
    disableAutoFocusItem
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "left",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "left",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      fontSize: 14,
      "& .MuiSvgIcon-root, & .lucide": {
        fontSize: MENU_ITEM_ICON_SIZE,
        color: theme.palette.text.secondary,
      },
      // See MENU_ITEM_ICON_SIZE: Lucide icons need the explicit dimensions
      // that MUI icons already derive from the font-size above.
      "& .lucide": {
        width: MENU_ITEM_ICON_SIZE,
        height: MENU_ITEM_ICON_SIZE,
      },
      // Gap between a leading icon and its label. Scoped to the item's first
      // icon so a trailing icon (e.g. a fly-out chevron) sits flush with the
      // item's right padding edge without needing a consumer override.
      "& .MuiSvgIcon-root:first-of-type, & .lucide:first-of-type": {
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity,
        ),
      },
    },
  },
}));
